export default "/static/dashboard/build/app/img/v2/68fcb80f35344f24af4359359944bbc2.png";